import { OrganisationTypeConstants } from "../../../../../constants";
import { AssetManagerSingleCardTemplate, DeveloperSingleCardTemplate } from "../../../../../templates";
import { useAuth } from "../../../../../useAuth";
import { InviteForm } from "./form";
import { useInvite } from "./useInvite";

export const Invite = (): JSX.Element => {
  const { currentUserType } = useAuth();
  const { handleBackClick } = useInvite();
  const isAssetManager = currentUserType === OrganisationTypeConstants.ASSET_MANAGER;
  // ProjectAccessInviteFields carries the "New access invitation" heading and the info box.
  const content = <InviteForm />;

  return isAssetManager ? (
    <AssetManagerSingleCardTemplate
      pageTitle="Settings"
      handleBackClick={handleBackClick}
      backButtonText="Back to project access"
      activeElement="Settings"
    >
      {content}
    </AssetManagerSingleCardTemplate>
  ) : (
    <DeveloperSingleCardTemplate
      pageTitle="Settings"
      handleBackClick={handleBackClick}
      backButtonText="Back to project access"
    >
      {content}
    </DeveloperSingleCardTemplate>
  );
};
